var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-app',{attrs:{"params":_vm.f7params}},[_c('left-menu'),_vm._v(" "),_c('f7-views',{staticClass:"safe-areas",attrs:{"tabs":""}},_vm._l((_vm.views),function(v){return _c('f7-view',{key:v,attrs:{"id":'view-' + v,"name":v,"tab":"","url":'/' + v}})}),1),_vm._v(" "),_c('auth0')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }